import { useState } from 'react'

export default function useModalController() {
  const [openedModals, setOpenedModals] = useState({})

  function openModal(modalName, payload) {
    setOpenedModals({
      ...openedModals,
      [modalName]: {
        isOpen: true,
        payload,
      },
    })
  }

  function closeModal(modalName) {
    setOpenedModals({
      ...openedModals,
      [modalName]: {
        isOpen: false,
      },
    })
  }

  return {
    openModal,
    closeModal,
    openedModals,
  }
}
